/* eslint-disable react/prop-types */
// ** React Imports
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom'; // ** Replace useRouter with useHistory and useLocation
import { useNavigate } from 'react-router-dom'; // Import useNavigate from react-router-dom
// ** Hooks Import
import { useAuth } from 'hooks/auth/useAuth';

const GuestGuard = props => {
  const { children, fallback } = props;
  const auth = useAuth();
  const location = useLocation(); // ** Use useLocation to get current location
  const navigate = useNavigate(); // Use useNavigate instead of useHistory

  useEffect(() => {
    if (window.localStorage.getItem('kerpUserData2.1')) {
      if (location.pathname === '/auth/login') {
        // ** Use location.pathname to get current path
        navigate('/', { replace: true });
      }
    }
  }, [location.pathname, history]);

  if (auth.loading) {
    return fallback;
  }

  return <>{children}</>;
};

export default GuestGuard;
